// Content for top-nav sub-pages (real pages, not placeholders)
export const MARKETING = {
  solutions: {
    eyebrow: "Solutions",
    title: "One platform for the whole pediatric care journey",
    highlight: "whole",
    intro: "From first assessment to lasting progress — clinical tools built specifically for pediatric behavioral health.",
    hero: "/generated/coaching3.png",
    features: [
      ["Clinical Workflow & EHR", "Digital charting for developmental milestones, ABA logs, and speech/OT notes — all in one secure record.", "clinical-workflow-ehr"],
      ["Smart Telehealth", "HIPAA-compliant video with interactive whiteboards, digital puppets, games, and timers for engaging sessions.", "smart-telehealth"],
      ["Treatment Planning", "AI-assisted individualized care plans with goals, interventions, and home activities.", "treatment-planning"],
      ["Assessments & Screeners", "Automated delivery and scoring for M-CHAT, PHQ-A, GAD-7, and Vanderbilt scales.", "assessments-screeners"],
    ],
    stats: [["10,000+", "Children Supported"], ["95%", "Provider Satisfaction"], ["4.9/5", "Clinician Rating"]],
  },
  families: {
    eyebrow: "For Families",
    title: "Support that follows your child everywhere",
    highlight: "everywhere",
    intro: "Stay connected to your child's care team, track progress, and practice strategies at home with confidence.",
    hero: "/generated/coaching1.png",
    features: [
      ["Parent Portal", "See appointments, goals, and progress at a glance — from any device.", "parent-portal"],
      ["Parent Coaching Hub", "On-demand lessons, masterclasses, and at-home exercises created by specialists.", "parent-coaching-hub"],
      ["Progress Tracking", "Child-friendly mood and behavior tracking for sleep, anxiety, and daily wins.", "progress-tracking"],
      ["At-Home Activities", "Guided routines and visual schedules that reinforce therapy between sessions.", "at-home-activities"],
    ],
    stats: [["2,500+", "Families Empowered"], ["28%", "Faster Progress"], ["24/7", "Access"]],
  },
  providers: {
    eyebrow: "For Providers",
    title: "Coordinate care across every specialist",
    highlight: "every",
    intro: "Purpose-built for BCBAs, therapists, pediatricians, and school teams to collaborate seamlessly.",
    hero: "/generated/pediatrician_male.png",
    features: [
      ["BCBAs & Therapists", "ABA data collection, session notes, and outcome tracking in one workflow.", "bcbas-therapists"],
      ["Pediatricians", "Shared records and referrals that keep medical and behavioral care aligned.", "pediatricians"],
      ["Schools & IEP Teams", "Teacher portal to view IEPs, log behaviors, and message the care team.", "schools-iep-teams"],
      ["Care Coordination", "Secure messaging and shared plans across the entire circle of care.", "care-coordination"],
    ],
    stats: [["500+", "Care Professionals"], ["60%", "Less Admin Time"], ["HIPAA", "Compliant"]],
  },
  resources: {
    eyebrow: "Resources",
    title: "Learn, grow, and stay informed",
    highlight: "grow",
    intro: "Guides, webinars, and case studies to help clinicians and families support brighter futures.",
    hero: "/generated/coaching2.png",
    features: [
      ["Guides & Articles", "Evidence-based reading on autism, ADHD, anxiety, and developmental milestones.", "guides-articles"],
      ["Webinars", "Live and recorded sessions with leading pediatric behavioral health experts.", "webinars"],
      ["Case Studies", "Real-world outcomes from clinics and families using ProactiveBH.", "case-studies"],
      ["Help Center", "Step-by-step support articles and best practices for every feature.", "help-center"],
    ],
    stats: [["200+", "Articles"], ["50+", "Webinars"], ["Weekly", "New Content"]],
  },
  about: {
    eyebrow: "About",
    title: "On a mission for brighter tomorrows",
    highlight: "brighter",
    intro: "We believe every child deserves proactive, coordinated, and compassionate behavioral health care.",
    hero: "/generated/clinician_female.png",
    features: [
      ["Our Mission", "To connect clinicians, families, and schools so every child can thrive.", "our-mission"],
      ["Leadership", "A team of BCBAs, pediatricians, and technologists dedicated to kids.", "leadership"],
      ["Careers", "Join us in building the future of pediatric behavioral health.", "careers"],
      ["Contact", "We'd love to hear from you — reach out anytime.", "contact"],
    ],
    stats: [["2019", "Founded"], ["10,000+", "Children Supported"], ["48", "States"]],
  },
};
